import { render } from "./NamedCartsConsumer.vue?vue&type=template&id=64f567f9&scoped=true"
import script from "./NamedCartsConsumer.vue?vue&type=script&lang=js"
export * from "./NamedCartsConsumer.vue?vue&type=script&lang=js"

import "./NamedCartsConsumer.vue?vue&type=style&index=0&id=64f567f9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../jiffyshirts/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.6_vue@3.5.6_typescript@5.7.3__webpack@5.96.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f567f9"]])

export default __exports__